import { useState, useEffect, useRef } from "react";
import Table from "../../sharedPages/CommonComponents/Table";
import {
  ArrowDropDownIcon,
  DatePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import useApi from "../../../helpers/apiHelper/requestHelper";
import download from "../../../assets/images/download.svg";
import Avatar from "../../../assets/images/Profile.svg";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { getMemberCommunityDisplayName } from "../../../helpers/memberCommunityDisplay";
import "./VerifiedPaymentBillingHistory.css";
import "./VerifyTradeHistory.css";

const memberColumns = [
  { key: "groupName", label: "Group name",type:"profile" },
  { key: "price", label: "Price" },
  { key: "month", label: "Date" },
  {
    key: "status",
    label: "Status",
    render: (row) => (
      <span className={row.status === "PAID" ? "statusPaid" : "statusUnpaid"}>
        {row.status}
      </span>
    ),
  },
  { key: "renews", label: "Renews" },
  {
    key: "invoice",
    label: "Invoice",
    render: (row) => (
      <button
        type="button"
        className="download-btn"
        onClick={() => {
          const link = document.createElement("a");
          link.href = row.invoice_pdf;
          link.download = "invoice.pdf";
          link.target = "_blank";
          link.rel = "noopener noreferrer";
          // document.body.appendChild(link); — removed: conflicts with React 18 concurrent DOM reconciliation
          link.click();
          // document.body.removeChild(link); — removed: modern browsers support link.click() without DOM insertion
        }}
      >
        <img src={download} alt="Download" />
      </button>
    ),
  },
];
const leaderColumns = [
  { key: "groupName", label: "Group name", type: "profile" },
  { key: "price", label: "Price" },
  { key: "month", label: "Date" },
  {
    key: "status",
    label: "Status",
    render: (row) => (
      <span className={row.status === "PAID" ? "statusPaid" : "statusUnpaid"}>
        {row.status}
      </span>
    ),
  },
  { key: "renews", label: "Renews" },
  {
    key: "invoice",
    label: "Invoice",
    render: (row) => (
      <button
        type="button"
        className="download-btn"
        onClick={() => {
          const link = document.createElement("a");
          link.href = row.invoice_pdf;
          link.download = "invoice.pdf";
          link.target = "_blank";
          link.rel = "noopener noreferrer";
          // document.body.appendChild(link); — removed: conflicts with React 18 concurrent DOM reconciliation
          link.click();
          // document.body.removeChild(link); — removed: modern browsers support link.click() without DOM insertion
        }}
      >
        <img src={download} alt="Download" />
      </button>
    ),
  },
];

// Separate Date Selector Component for exact date filtering
const ExactDateSelector = ({ selectedDate, setSelectedDate, user }) => {
  const [open, setOpen] = useState(false);
  const closingRef = useRef(false);

  const closePicker = () => {
    closingRef.current = true;
    setOpen(false);
    setTimeout(() => { closingRef.current = false; }, 300);
  };

  // Calculate minDate from user's createdAt
  const minDate = user?.createdAt
    ? dayjs(user.createdAt)
    : dayjs().subtract(100, "year"); // Default to 100 years ago if no createdAt
  const maxDate = dayjs();

  // Validate if selected date is before user creation
  useEffect(() => {
    if (selectedDate && dayjs(selectedDate).isBefore(minDate, 'day')) {
      setSelectedDate(null);
      // You could also show a toast/notification here if needed
      console.warn("Selected date cannot be before account creation");
    }
  }, [selectedDate, minDate, setSelectedDate]);

  const handleClear = (e) => {
    e.stopPropagation();
    setSelectedDate(null);
  };

  return (
    // style={{ position: "relative", cursor: "pointer" }} — moved to style.css .exactDateSelectBox
    <div
      className="exactDateSelectBox"
      onClick={() => {
        if (!closingRef.current) setOpen(true);
      }}
    >
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          className="memberDropDown"
          open={open}
          onOpen={() => {
            if (!closingRef.current) setOpen(true);
          }}
          onClose={closePicker}
          onAccept={closePicker}
          label="Select Date"
          format="DD-MM-YYYY"
          value={selectedDate}
          onChange={(date) => {
            // Validate before setting
            if (date && dayjs(date).isBefore(minDate, 'day')) {
              // Optionally show error message
              console.warn("Cannot select date before account creation");
              return;
            }
            setSelectedDate(date);
            closePicker();
          }}
          minDate={minDate}
          maxDate={maxDate}
          shouldDisableDate={(date) => {
            // Disable dates before user creation
            return dayjs(date).isBefore(minDate, "day");
          }}
          // maxDate={dayjs()}
          slotProps={{
            textField: {
              className: `yearlyDatePicker ${selectedDate ? "bg-white" : ""}`,
              placeholder: "Select exact date",
              size: "small",
              onClick: (e) => {
                e.stopPropagation();
                if (!closingRef.current) setOpen(true);
              },
              sx: {
                "& .MuiFormLabel-root": {
                  fontSize: "14px",
                  fontFamily: "Graphik Medium",
                  color: "#9A9B9B",
                  paddingTop: "6px",
                },
                "& .MuiOutlinedInput-root": {
                  minHeight: "55px",
                  fontSize: "14px",
                  color: "#9A9B9B",
                  fontFamily: "Graphik Medium",
                  "& fieldset": {
                    borderColor: selectedDate ? "#11B700" : "transparent",
                    borderWidth: "2px",
                    borderRadius: "12px",
                    fontFamily: "Graphik Medium",
                  },
                  "&:hover fieldset": {
                    borderColor: selectedDate ? "#11B700" : "#ccc",
                    borderWidth: "2px",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#11B700",
                    borderWidth: "2px",
                  },
                },
              },
            },
          }}
          slots={{
            openPickerIcon: ArrowDropDownIcon,
          }}
        />
      </LocalizationProvider>
      {selectedDate && (
        <IconButton
          onClick={handleClear}
          size="small"
          sx={{
            backgroundColor: "#fff",
            position: "absolute",
            right: "4px",
            top: "50%",
            transform: "translateY(-50%)",
            padding: "10px",
            zIndex: 1,
            "&:hover": {
              backgroundColor: "#f1f1f1",
            },
          }}
        >
          <CloseIcon sx={{ fontSize: "18px", color: "#9A9B9B" }} />
        </IconButton>
      )}
    </div>
  );
};

// Year Selector Component
const YearSelector = ({ selectedYear, setSelectedYear, open, setOpen }) => {
  const handleClear = (e) => {
    e.stopPropagation();
    setSelectedYear(null);
  };

  return (
    // <div className="memberFilteDropdown mb-40px">
    <div className="yearSelectBox">{/* was: style={{ position: "relative", width: "max-content" }} — moved to VerifyTradeHistory.css */}
      <LocalizationProvider dateAdapter={AdapterDayjs} >
        <DatePicker
          open={open}
          onClose={() => setOpen(false)}
          onOpen={() => setOpen(true)}
          label="Select Year"
          value={selectedYear ? dayjs().year(selectedYear) : null}
          onChange={(date) => {
            if (date) {
              setSelectedYear(date.year());
            } else {
              setSelectedYear(null);
            }
            setOpen(false);
          }}
          maxDate={dayjs()}
          openTo="year"
          views={["year"]}
          yearsOrder="desc"
          slots={{
            openPickerIcon: ArrowDropDownIcon,
          }}
          slotProps={{
            textField: {
              className: `yearlyDatePicker ${selectedYear ? "bg-white" : ""}`,
              placeholder: "Select year",
              size: "small",
              onClick: () => setOpen(true),
              inputProps: {
                readOnly: true,
                InputLabelProps: { shrink: true },
                style: {
                  cursor: "pointer",
                  fontSize: "14px",
                  fontFamily: "Graphik Medium",
                },
              },
              sx: {
                "& .Mui-selected": {
                  backgroundColor: "red",
                },
                "& .MuiFormLabel-root": {
                  fontSize: "14px",
                  fontFamily: "Graphik Medium",
                  color: "#9A9B9B",
                  paddingTop: "6px",
                },
                "& .MuiOutlinedInput-root": {
                  minHeight: "55px",
                  fontSize: "14px",
                  color: "#9A9B9B",
                  fontFamily: "Graphik Medium",
                  "& fieldset": {
                    borderColor: selectedYear ? "#11B700" : "transparent",
                    borderWidth: "2px",
                    borderRadius: "12px",
                    fontFamily: "Graphik Medium",
                  },
                  "&:hover fieldset": {
                    borderColor: selectedYear ? "#11B700" : "#ccc",
                    borderWidth: "2px",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#11B700",
                    borderWidth: "2px",
                  },
                },
              },
            },
          }}
        />
      </LocalizationProvider>
      {selectedYear && (
        <IconButton
          onClick={handleClear}
          size="small"
          sx={{
            backgroundColor: "#fff",
            position: "absolute",
            right: "4px",
            top: "50%",
            transform: "translateY(-50%)",
            padding: "10px",
            zIndex: 1,
            "&:hover": {
              backgroundColor: "#f1f1f1",
            },
          }}
        >
          <CloseIcon sx={{ fontSize: "18px", color: "#9A9B9B" }} />
        </IconButton>
      )}
      {/* </div> */}
    </div>
  );
};

const VerifyTradeHistory = () => {
  const [tableData, setTableData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedYear, setSelectedYear] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [filteredTableData, setFilteredTableData] = useState([]);
  const [openYearPicker, setOpenYearPicker] = useState(false);

  const api = useApi();
  const user = useSelector((state) => state?.user?.user);

  useEffect(() => {
    const fetchInvoices = async () => {
      try {
        const response = await api("post", "users/getInvoices");
        if (response?.data) {
          const mapped = response.data.map((invoice) => {
            const periodStartDate = new Date(invoice.period_start * 1000);
            const periodEndDate =
              invoice.period_end === "one_time"
                ? null
                : new Date(invoice.period_end * 1000);
            let groupName;
            let logo;
            if (user?.role === "leader") {
              groupName =
                user?.tradeName ||
                user?.mainLeader?.tradeName ||
                user?.leaderCommunity?.disPlayName;
              logo = user?.leaderCommunity?.logo || null;
            } else if (user?.role === "member" || user?.role === "memberNoLink") {
              groupName = getMemberCommunityDisplayName(user);
              logo =
                user?.memberCommunities?.[0]?.subscribed
                  ? user?.memberCommunities?.[0]?.community?.logo || null
                  : user?.role === "memberNoLink"
                    ? null
                    : user?.memberCommunities?.[0]?.community?.logo || null;
            }
            return {
              groupName,
              logo,
              price: `$${(invoice.amount_paid / 100).toFixed(2)}`,
              month: `${periodStartDate
                .getDate()
                .toString()
                .padStart(2, "0")}-${(periodStartDate.getMonth() + 1)
                .toString()
                .padStart(2, "0")}-${periodStartDate.getFullYear()}`,
              year: periodStartDate.getFullYear(),
              status: invoice.paid ? "PAID" : "UNPAID",
              renews:
                invoice.period_end === "one_time"
                  ? "Never"
                  : // (invoice?.renewal_date && new Date(invoice?.renewal_date * 1000).toLocaleDateString("en-US")) || periodStartDate.toLocaleDateString("en-US"),
                    (invoice?.renewal_date &&
                      dayjs(invoice?.renewal_date * 1000).format("DD-MM-YYYY")) ||
                    dayjs(periodStartDate).format("DD-MM-YYYY"),
              invoice_pdf: invoice.invoice_pdf,
              exactDate: periodStartDate,
              originalData: invoice,
            };
          });
          setTableData(mapped);
        }
      } catch (error) {
        console.error("Error fetching invoices:", error);
      }
    };
    fetchInvoices();
  }, []);

  // Helper function to check if two dates are the same day
  const isSameDate = (date1, date2) => {
    if (!date1 || !date2) return false;

    const d1 = dayjs(date1);
    const d2 = dayjs(date2);

    return d1.format("YYYY-MM-DD") === d2.format("YYYY-MM-DD");
  };

  // Filter logic that handles both year and exact date filtering
  useEffect(() => {
    const filterData = (data, query, selectedYear, selectedDate) => {
      let filtered = data;

      // Filter by search query (text search)
      if (query.trim()) {
        filtered = filtered.filter((item) =>
          Object.values(item).some((value) =>
            value?.toString().toLowerCase().includes(query.toLowerCase()),
          ),
        );
      }

      // Filter by year
      if (selectedYear) {
        filtered = filtered.filter((item) => item.year === selectedYear);
      }

      // Filter by exact date (this will override year filter if both are selected)
      if (selectedDate) {
        filtered = filtered.filter((item) => {
          return isSameDate(item.exactDate, selectedDate.toDate());
        });
      }

      return filtered;
    };

    setFilteredTableData(
      filterData(tableData, searchQuery, selectedYear, selectedDate),
    );
    setCurrentPage(1); // Reset to page 1 on any filter change
  }, [tableData, searchQuery, selectedYear, selectedDate]);

  // Pagination logic
  const totalPages = Math.ceil(filteredTableData.length / itemsPerPage);
  const paginatedData = filteredTableData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage,
  );

  // Clear filters functions
  const clearYearFilter = () => {
    setSelectedYear(null);
  };

  const clearDateFilter = () => {
    setSelectedDate(null);
  };

  const clearAllFilters = () => {
    setSelectedYear(null);
    setSelectedDate(null);
    setSearchQuery("");
  };

  return (
    <div>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <div className="tableWrapper verifiedBilling">
          {user?.role === "leader" && (
            <h2 className="billingHistoryTitle">Billing History</h2>
          )}
          {/* Filter Controls */}
          <div
            className="tableCaptionWrap billingHistoryFiltrationCL"
            style={{
              gap: "1rem",
              paddingTop: `${user?.role !== "leader" ? "" : ""}`,
            }}
          >
            {/* Year Filter */}
            <div className="billingYearFilter">
              <div className="billingHistoryFiltration">
                <YearSelector
                  selectedYear={selectedYear}
                  setSelectedYear={setSelectedYear}
                  open={openYearPicker}
                  setOpen={setOpenYearPicker}
                />
              </div>
            </div>

            {/* Date Filter and Search */}
            <div className="billingDateFilter position-relative">
              <div className="d-flex align-items-center billingDateFilterRow gap-3">
                {/* Exact Date Filter */}
                <ExactDateSelector
                  user={user}
                  selectedDate={selectedDate}
                  setSelectedDate={setSelectedDate}
                />
              </div>
            </div>
          </div>
            {paginatedData.map((row, index) => (
              <div className="subs__card-wrapper">
                <div className="subs__card" key={index}>
                  <div className="subs__card-header">
                    <span className="card__header-pair">
                      <img src={user?.memberCommunities[0]?.community?.logo||Avatar} alt="profile" />
                      {row.groupName}
                    </span>
                    <span className="card__header-Badge">{row.price}</span>
                  </div>
                  <div className="d-flex align-items-end justify-content-between">
                    <span className="isolated-label">{row.renews}</span>
                    <div className="d-flex gap-2 align-items-end">
                      <div>
                        <div className="subs__card-mValue">Download Invoice</div>
                      </div>
                      <div>
                        <div className="subs__card-mValue">
                          <button
                            type="button"
                            className="download-btn"
                            onClick={() => {
                              const link = document.createElement("a");
                              link.href = row.invoice_pdf;
                              link.download = "invoice.pdf";
                              link.target = "_blank";
                              link.rel = "noopener noreferrer";
                              // document.body.appendChild(link); — removed: conflicts with React 18 concurrent DOM reconciliation
                              link.click();
                              // document.body.removeChild(link); — removed: modern browsers support link.click() without DOM insertion
                            }}
                          >
                            <img src={download} alt="Download" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}

        {/* Table */}
        <div className="verifyTradeHistoryTable">
          <Table
            columns={user?.role==="leader" ? leaderColumns : memberColumns}
            data={paginatedData}
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={setCurrentPage}
            stylingComp={{ marginTop: "0px" }}
          />
        </div>

          {/* Mobile View Placeholder */}
          <div className="tableMobView d-none">
            {/* Add mobile view mapping if needed */}
          </div>
        </div>
      </LocalizationProvider>
    </div>
  );
};

export default VerifyTradeHistory;
